/**
 * Módulo que permite ejecutar una cola global
 * de promesas de forma síncrona y secuencial
 *
 * La callback debe retornar una promesa
 * En caso de error, debe llamar al reject() de la promesa
 * para no continuar con la ejecución de la cola
 *
 * @use `agregarACola(() => {
 *  return new Promise(async (resolve, reject) => {
 *    // llamada asincrona
 *    const request = await fetch("http://holamundo.com");
 *
 *    if(request.error) {
 *      // Ocurrió un error, finalizar la cola
 *      reject();
 *    } else {
 *      // Continuar con la sig ejecución
 *      resolve();
 *    }
 *  })
 * })`
 */
import Vue from "@/bus";

/**
 * Cola de promesas a ejecutar
 */
let __cola = [];

/**
 * Ejecuta la cola de promesas
 */
function __ejectutarCola() {
  Vue.$log.info("promisequeue", "EJECUTANDO COLA", __cola);
  __cola.forEach(async (item, index) => {
    const itemPrev =
      index > 0
        ? __cola[index - 1]
        : {
            done: true
          };
    if (itemPrev.done && !item.done && !item.pending) {
      Vue.$log.info("promisequeue", "EJECUTANDO ITEM", index);
      item.pending = true;
      try {
        await item.cb();
        item.done = true;
        item.pending = false;
      } catch (error) {
        Vue.$log.error("promisequeue", "ERROR", error);
        __cola = [];
      }
      Vue.$log.info("promisequeue", "FINALIZADO ITEM", index);
      __ejectutarCola();
    }
  });
}

/**
 * Agrega una callback asíncrona a la cola
 * @param {async function} cb Función que devuelve una promesa
 */
export function agregarACola(cb) {
  __cola.push({
    done: false,
    pending: false,
    cb
  });
  __ejectutarCola();
}
